export const LOGIN_PATH = '/login';

export const FORGOT_PASS_PATH = `/forgot-password`;
